export const CONTACT_US_URL = 'https://www.zenbusiness.com/contact-us/';

export const EIN_CREATION_JOURNEY_PATH = '/journeys/service/ein_creation/:businessEntityUuid';

export const LLC_FORMATION_JOURNEY_PATH = '/journeys/service/llc_formation/:businessEntityUuid';

export const DISCLOSURE_TEXT = `
ZenBusiness is a financial technology company and is not a bank. Banking services provided
by Thread Bank, Member FDIC. The ZenBusiness Visa Debit Card is issued by Thread Bank
pursuant to a license from Visa U.S.A. Inc. and may be used anywhere Visa debit cards
are accepted. FDIC insurance is available for funds on deposit through Thread Bank, Member FDIC.`;

export const AFFILIATE_DISCLOSURE_TEXT = `
This page contains affiliate links. ZenBusiness may receive compensation if you
make a purchase with any of the third parties listed.`;

export const businessTypes = {
  llc: 'Limited Liability Company',
  corp: 'Corporation',
  sole_prop: 'Sole Proprietorship'
};

// Intl formats to be used in the IntlProvider
export const intlFormats = {
  number: {
    currency: {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }
  }
};
